export enum UserAdminComponentTypeEnum {
  PRIVILEGE = 'PRIVILEGE',
  ALL = 'ALL',
  'BLOCKED' = 'BLOCKED'
}
